import { type FC } from 'react'
import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const FormTemplateTimeline: FC<DeltaTrialTimelineProps> = (props) => {
  return <TrialTimeline featureName='Document Fill' {...props} />
}
